import { Component } from '@angular/core';
import { ENTRANCE_HISTORY_URL } from '../../../resources/config';

@Component({
  selector: 'app-entrance-history-banner',
  templateUrl: './entrance-history-banner.component.html',
  styleUrls: ['./entrance-history-banner.component.scss']
})
export class EntranceHistoryBannerComponent {
  entranceHistoryUrl = ENTRANCE_HISTORY_URL;
}
